import styled, { css } from 'styled-components';
export const ListItemWrapper = styled.div `
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  min-height: 38px;
  max-height: 38px;
  height: 38px;
  padding: 0 0 0 16px;
  list-style: none;
  font-size: 14px;
  background-color: ${({ theme }) => theme.colors.White};
  ${({ theme }) => theme.fonts.PoppinsTextMedium};

  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.Grey1};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.Grey2};
    color: ${({ theme }) => theme.colors.PrimaryHover};

    &:active {
      background-color: ${({ theme }) => theme.colors.Grey3};
      color: ${({ theme }) => theme.colors.PrimaryClick};
    }
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.Grey3};
    color: ${({ theme }) => theme.colors.PrimaryClick};
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.Grey2};
    color: ${({ theme }) => theme.colors.PrimaryClick};
  }

  ${({ tabSize }) => tabSize &&
    css `
      padding-left: ${`${tabSize * 24 + 16}px`};
    `}

  ${({ disabled }) => disabled &&
    css `
      background-color: ${({ theme }) => theme.colors.Grey3};
      color: ${({ theme }) => theme.colors.TextDisabled};
    `}
  
    ${({ isTargeted }) => isTargeted &&
    css `
      background-color: ${({ theme }) => theme.colors.Grey2} !important;
    `}
`;
export const ListItemText = styled.p `
  margin: 0;
  font-size: 14px;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  user-select: none;
`;
export const ListItemSubLabelText = styled.p `
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  margin-left: auto;
  white-space: nowrap;
  overflow: unset;
  text-overflow: unset;
  width: unset;
`;
export const ListItemIconWrapper = styled.div `
  position: absolute;
  right: 16px;
`;
export const SubLabel = styled.span `
  ${({ theme }) => theme.typography.Caption};
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  right: 50px;
  position: absolute;
`;
//# sourceMappingURL=index.js.map